module.exports = __webpack_public_path__ + "static/media/Version.c70b964c.txt";


//////////////////
// WEBPACK FOOTER
// ./src/Version.txt
// module id = 126
// module chunks = 1